<template>
    <div class="panel" :class="colorHeading" v-if="acteurReference.Nom">
      <div class="panel-heading go-panel-heading" @click="isOpen=!isOpen" :title="titleMessage">
          <h5 class="panel-title panel-primary"><strong>{{acteurReference.Role}} :</strong> {{acteurReference.Nom}}
            <i class="glyphicon pull-right"
               :class="{'glyphicon-chevron-down': isOpen,'glyphicon-chevron-right': !isOpen }">
            </i>
          </h5>
      </div>
      <div class="panel-body" :class="{hide: !isOpen }" ref="panelBody">
          Nom : {{acteurReference.Nom}}<br>
        <p v-if="acteurReference.IdActeur">Identifiant : [{{acteurReference.IdActeur}}]</p>
        <p v-if="acteurReference.AdresseCorresp">Adresse : {{acteurReference.AdresseCorresp | convertReturn2Comma}}</p>
        <p v-if="acteurReference.telephone">tel : {{acteurReference.telephone}}</p>
        <p v-if="acteurReference.fax">fax : {{acteurReference.fax}}</p>
          <p v-if="acteurReference.email">email: {{acteurReference.email}}</p>
        <slot>
        </slot>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'go-collapse-acteur-role-details',
    components: {},
    data: function () {
      return {
        isOpen: this.open
      }
    }, // end of data section
    props: {
      open: {
        type: Boolean,
        default: false
      },
      acteurReference: {
        type: Object
      }
    },
    watch: {
      open: function (val) {
        this.isOpen = val
      }
    },
    computed: {
      colorHeading: function () {
        return {
          'panel-primary': this.isOpen,
          'panel-info': !this.isOpen
        }
      },
      titleMessage: function () {
        if (this.isOpen) {
          return 'Cliquez pour cacher le détail'
        } else {
          return 'Cliquez pour voir plus de détail'
        }
      }
    }, // end of computed props section

    mounted: function () {
    }, // end of computed props section

    filters: {
      convertReturn2Comma: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.replace('\n', ', ')
      }
    },

    methods: {} // end of methods section
  }
</script>


<style lang="scss">

  .hide {
    display: none;
  }
  .go-panel-heading {
    cursor: pointer;
    &:hover {
      background-color: #2aabd2;  // TODO use a variable lighter then heading
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ui/goCollapseActeurRoleDetails.vue